type permissionMapping = {
    [key: string]: {
        controller: string;
        function: string;
    };
};

export const headerMenumapping: permissionMapping = {
    // header menu mapping
    'Map_All': { controller: 'customerMap', function: 'MapAll' },
    'primaryMatrics': { controller: 'customerMap', function: 'primaryMatrics' },
    'Diagnosis': { controller: 'customerMap', function: 'diagnosis' },
};
